import React from 'react';
import './App.css'; 

const Home = () => {
    return ( 
        <>
        <div className="page-background">
        <img className='logo-image' src="image/logo.jpg" alt="Logo"/>
        <p className="centered-paragraph">
        
        The advanced application uCheckly is a comprehensive testing application that provides you with all the tools required to test and locate problems on your mobile device in a reliable and efficient way. With a friendly and easy-to-use user interface, uCheckly allows you to check and diagnose important functions such as WiFi connection, GPS location, microphone, speaker, face id, and more.
        </p>
        <a href='https://apps.apple.com/app/id6478163311'>
        <img className='download-image' src="image/download.svg" alt="download"/>
        </a>
        <a id="privacy-policy-link"><a href='/privacyPolicy' >Privacy Policy</a> | <a href='/termsOfUs' >Terms of Use</a> | <a href='/accessibilityStatement' >Accessibility Statement</a></a>
        </div>
        </>
     );
}
 
export default Home;